module.exports = __webpack_public_path__ + "static/3-002-52c24f2de7417f58f23359c286607122.png";